import { useOutletContext } from "react-router-dom";

import PageAbstract from "components/PageAbstract";
import FilesManager from "components/FilesManager";
import _request from "actions/_request";
import _helper from "actions/_helper";
import i18n from "i18";

import { Box, Typography } from "@mui/material";

class ContentPage extends PageAbstract {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      files: [],
      used: 0,
    };
  }

  async loadData() {
    const resp = await _request.files.getAll();
    this.state.files = resp?.data?.items || [];
    this.state.used = resp?.data?.used || 0;
  }

  newFolder() {
    this.filesManager?.newFolder();
  }

  uploadDialog() {
    this.filesManager?.uploadDialog();
  }

  renderTopPanel(used, userPackage, filesLength) {
    // storage_mb lives in limits (new API); fall back to legacy permissions.storage (in MB)
    const storageMb =
      userPackage.limits?.storage_mb ??
      (() => {
        try {
          const perms =
            typeof userPackage.permissions === "string"
              ? JSON.parse(userPackage.permissions || "{}")
              : userPackage.permissions || {};
          return perms.storage ?? 0;
        } catch {
          return 0;
        }
      })();
    const isUnlimited = storageMb === -1;
    const total = storageMb * 1048576;

    return (
      <Box className="flex between centerV bgDarkTheme pad10 h-[5.313rem]">
        <Box className="flex1 flex gap8 font f28 col black07">
          <Typography
            className="page-title"
            sx={{ padding: 5, color: "var(--text-color)" }}>
            {i18n.t("fileManager.title")}
          </Typography>
        </Box>
        <Box className="flex1 flex center gap8">
          <Typography sx={{ fontSize: 17, color: "#ffffff" }}>
            {i18n.t("fileManager.storage")}:
          </Typography>
          <Box
            className="flex w700 gap4"
            sx={{ fontSize: 17, color: "var(--text-color)" }}>
            <Box>{_helper.formatBytes(used)}</Box>
            <Box>/</Box>
            <Typography className="col darkThemeText">
              {isUnlimited ? "∞" : _helper.formatBytes(total)}
            </Typography>
          </Box>
        </Box>
        <Box className="flex gap8">
          {filesLength > 0 && (
            <Box className="btnDark" onClick={() => this.uploadDialog()}>
              {i18n.t("fileManager.upload")}
            </Box>
          )}
          <Box className="btnDark" onClick={() => this.newFolder()}>
            {i18n.t("fileManager.createNewFolder")}
          </Box>
        </Box>
      </Box>
    );
  }

  renderPage() {
    const { files, used } = this.state;
    const { files_extensions, userPackage } = this.props.metaData;
    const accept = _helper.formFilesAccept(files_extensions);

    return (
      <Box className="flex1 flex column gap16">
        {this.renderTopPanel(used, userPackage, files.length)}
        <FilesManager
          ref={(el) => (this.filesManager = el)}
          accept={accept}
          files={files}
          refresh={this.refresh.bind(this)}
          width={176}
          height={176}
          padding="25px 45px"
        />
      </Box>
    );
  }
}

export default function Content() {
  return <ContentPage {...useOutletContext()} />;
}
